import { toAddress } from "../../utils/address";
import AddressForm from "./AddressForm";

export interface IAddress {
  t: any;
  language: string;
  data: any;
  onChange: (address: string) => void;
  required?: boolean;
  error?: any;
}

export const Address = ({
  t,
  language,
  data,
  onChange,
  required,
  error,
}: IAddress) => {
  return (
    <AddressForm
      t={t}
      language={language}
      data={toAddress(data)}
      onChange={onChange}
      required={required}
      error={error}
    />
  );
};
